module.exports = __webpack_public_path__ + "media/images/lp_v6_img17-82733047cb21531825f509ae1a6b9e55.webp";